/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsAnomalySystem extends models.RecommendationBaseForFinOps {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsAnomalySystem");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsAnomalySystem.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsAnomalySystem>): RecommendationForFinopsAnomalySystem {
        let obj = Object.assign(new RecommendationForFinopsAnomalySystem(), model);
        RecommendationForFinopsAnomalySystem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsAnomalySystem>): RecommendationForFinopsAnomalySystem {
        if (!model) return null;
        return RecommendationForFinopsAnomalySystem.newInstance(<RecommendationForFinopsAnomalySystem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsAnomalySystem) {
        if (!obj) return;

        models.RecommendationForFinopsAnomalySystem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsAnomalySystem): boolean {
        if (models.RecommendationBaseForFinOps.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsAnomalySystem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
